<template>
  <div class="promoter-profit-list">
    <div class="profit-item" v-for="profitItem in profitList" :key="profitItem.id">
      <div class="header">
        <div class="order-id">{{ profitItem.business_order_id }}</div>
        <div class="profit">
          <span class="profit-label">佣金:</span>
          <span class="profit-value">{{ formatProfit(profitItem) }}</span>
          <span class="profit-unit">{{ formatCurrency(profitItem.currency) }}</span>
        </div>
      </div>
      <div class="content">
        <div class="profit-title">{{ profitItem.title }}</div>
        <div class="profit-status">
          {{ profitItem.status_text }}
        </div>
      </div>
      <div class="footer">
        <div class="profit-text">{{ formatProfitNote(profitItem) }}</div>
        <div class="date">
          {{ formatFullDate(profitItem.dt_created) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatFullDate } from '@/plugins/datefmt'
import { formatCurrency, formatPrice } from '@/plugins/price'
import { formatProfitRatio } from '@/plugins/promoter'

export default {
  props: {
    profitList: {
      type: Array,
      required: true,
    },
    isHideInfo: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatFullDate,
    formatCurrency,
    formatProfit(profitItem) {
      if (this.isHideInfo) {
        return '***'
      }
      return formatPrice(profitItem.profit, profitItem.currency)
    },
    formatProfitNote(profitItem) {
      let price = formatPrice(profitItem.total_price, profitItem.currency)
      let ratio = formatProfitRatio(profitItem.profit_ratio)
      if (this.isHideInfo) {
        ratio = '**%'
      }
      let currencyText = formatCurrency(profitItem.currency)
      return '金额 ' + price + ' ' + currencyText + ' x ' + ratio
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.promoter-profit-list {
  background: @antBackWhite;
}

.profit-item {
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: solid 1px @antLineGrey;

  &:first-child {
    border: none;
  }

  .header,
  .content,
  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .header,
  .footer {
    color: @antTextGrey;
  }

  .content {
    font-size: 18px;
    padding: 4px 0;
  }

  .order-id {
    font-size: 14px;
  }

  .profit {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .profit-label {
    font-size: 14px;
  }

  .profit-value {
    margin-left: 8px;
  }

  .profit-unit {
    margin-left: 4px;
    font-size: 14px;
  }

  .profit-text,
  .date {
    font-size: 14px;
  }
}
</style>
